import { render } from "./EventRegFamilyWards.vue?vue&type=template&id=1110839c&scoped=true"
import script from "./EventRegFamilyWards.vue?vue&type=script&lang=js"
export * from "./EventRegFamilyWards.vue?vue&type=script&lang=js"

import "./EventRegFamilyWards.vue?vue&type=style&index=0&id=1110839c&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1110839c"]])

export default __exports__